import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer.js';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol.js';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol.js';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol.js';
import type { RGB } from './symbology';

const COLORABLE = new Set([
  'polygon',
  'polyline',
  'point',
  'multipoint',
  'esriGeometryPolygon',
  'esriGeometryPolyline',
  'esriGeometryPoint',
  'esriGeometryMultipoint',
]);

export function isColorableGeometry(geometryType: string | undefined): boolean {
  return !!geometryType && COLORABLE.has(geometryType);
}

export function buildRenderer(geometryType: string | undefined, color: RGB): SimpleRenderer | undefined {
  if (!geometryType) return undefined;
  const [r, g, b] = color;
  switch (geometryType) {
    case 'polygon':
    case 'esriGeometryPolygon':
      return new SimpleRenderer({
        symbol: new SimpleFillSymbol({
          color: [r, g, b, 0.22],
          outline: { color: [r, g, b, 0.95], width: 0.8 },
        }),
      });
    case 'polyline':
    case 'esriGeometryPolyline':
      return new SimpleRenderer({
        symbol: new SimpleLineSymbol({
          color: [r, g, b, 0.95],
          width: 1.75,
        }),
      });
    case 'point':
    case 'multipoint':
    case 'esriGeometryPoint':
    case 'esriGeometryMultipoint':
      return new SimpleRenderer({
        symbol: new SimpleMarkerSymbol({
          style: 'circle',
          color: [r, g, b, 0.85],
          size: 7,
          outline: { color: [244, 236, 221, 1], width: 1 },
        }),
      });
    default:
      return undefined;
  }
}
